import {
  CustomerBucketAccessGrant,
  CustomerBucketAccessGrantCommandRequest,
  CustomerBucketAccessGrantCommandResponse,
  CustomerBucketAccessGrantCreate,
  CustomerBucketAccessGrantValidateResponse,
} from 'interfaces/customerBucketAccessGrant';
import { apiRequestHandlerPromise } from 'utils/apiRequestHandler';

const grantsUrl = (studyId: string, grantId?: string) =>
  `studies/${studyId}/customer-bucket-access-grants${grantId ? `/${encodeURIComponent(grantId)}` : ''}`;

export const customerBucketAccessGrantsQueryKey = (studyId: string) => ['customer-bucket-access-grants', studyId];

export const getCustomerBucketAccessGrants = (studyId: string, signal?: AbortSignal) =>
  apiRequestHandlerPromise<CustomerBucketAccessGrant[]>({
    url: grantsUrl(studyId),
    method: 'GET',
    signal,
  });

export const createCustomerBucketAccessGrant = (studyId: string, data: CustomerBucketAccessGrantCreate) =>
  apiRequestHandlerPromise<CustomerBucketAccessGrant>({
    url: grantsUrl(studyId),
    method: 'POST',
    data: JSON.stringify(data),
  });

export const disableCustomerBucketAccessGrant = (studyId: string, grantId: string) =>
  apiRequestHandlerPromise<CustomerBucketAccessGrant>({
    url: `${grantsUrl(studyId, grantId)}/disable`,
    method: 'POST',
  });

export const validateCustomerBucketAccessGrant = (studyId: string, grantId: string) =>
  apiRequestHandlerPromise<CustomerBucketAccessGrantValidateResponse>({
    url: `${grantsUrl(studyId, grantId)}/validate`,
    method: 'POST',
  });

export const generateCustomerBucketAccessGrantCommand = (
  studyId: string,
  grantId: string,
  data: CustomerBucketAccessGrantCommandRequest
) =>
  apiRequestHandlerPromise<CustomerBucketAccessGrantCommandResponse>({
    url: `${grantsUrl(studyId, grantId)}/commands`,
    method: 'POST',
    data: JSON.stringify(data),
  });
